export default (givenName: string, familyName: string): string => `${givenName} ${familyName}`.trim();